<app-modal-basic #modalRelatorio (closed)="destroyComponent()" [modalContentId]="'modal-rv'">
  <div class="app-modal-header">
    <h4 class="modal-title">Relatório de Comissão</h4>
  </div>
  <div class="app-modal-body">

    <form [formGroup]="impressaoForm" (ngSubmit)="submitForm()">
      <div class="row">
        <div class="form-group col-sm-12" rem5 combobox [type]="'vendedor'" (change)="checarPrepostoRepresentante()" appendTo="#modal-rv"
          [form]="impressaoForm" formControlName="vendedor">
        </div>
      </div>

      <div class="row">
          <div class="form-group col-sm-6 justify-content-center">
            <div class="checkbox-fade fade-in-default">
              <label>
                <input type="checkbox" [formControl]="checkBoxControl" [disabled]="true">
                <span class="cr">
                  <i class="cr-icon icofont icofont-ui-check txt-default"></i>
                </span>
                <span class="text-inverse">
                  Preposto
                </span>
              </label>
            </div>
          </div>
        </div>

      <div class="row">
        <div class="form-group col-sm-12">
          <label>Período</label>
          <div class="input-group">
            <app-data [calendarPosition]="'left'" formControlName="periodo1">
            </app-data>
            <span class="input-group-addon">até</span>
            <app-data formControlName="periodo2"></app-data>
          </div>
        </div>
      </div>

      <div class="alert alert-danger" *ngIf="modalErrors">
        <span>{{modalErrors}}</span>
      </div>

      <button type="submit" class="btn btn-primary ripple light">
        <i class="icofont icofont-refresh"> </i> OK
      </button>
      <button type="button" class="btn btn-danger ripple" (click)="modalRelatorio.hide()"><i class="ti ti-close"></i>
        Cancelar
      </button>
    </form>
  </div>
  <div class="app-modal-footer">
  </div>

</app-modal-basic>